import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const Select = ({ value, onChange, children }) => {
    return (_jsx(_Fragment, { children: _jsxs("select", { value: value, onChange: onChange, className: "bg-white border-2 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline", children: [_jsx("option", { value: '' }), children] }) }));
};
